import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.move-credit-card-items.views.MoveItemsWarningContent`

export default defineMessages({
  warningIntro: {
    id: `${scope}.warningIntro`,
    defaultMessage:
      'The following selected items have related items that will be moved together. {count} item(s) will be moved in total.',
  },
  movesWithRelatedItems: {
    id: `${scope}.movesWithRelatedItems`,
    defaultMessage: 'Moves with {count} related item(s)',
  },
})
